import { Task, TaskItem } from '../interfaces';
import { ItemStatus } from '../../store/interfaces';
import { currentWorkflowItemProvider } from '../../store/providers/currentWorkflowItemProvider';
import { getStore } from '../../store/store';

const updateCurrentTaskItem = (taskItem: TaskItem, status?: ItemStatus): void => {
  /** will move this update current workflow item in reducer */
  const currentWorkflowItem = getStore()?.state?.currentWorkflowItem;
  if (currentWorkflowItem) {
    const workflowItem = currentWorkflowItem;
    const config = JSON.parse(workflowItem.configuration);
    const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();

    const tasks = config.configWidgetJSON.tasks.map((task: Task) => {
      if (task.id === taskItem.taskId) {
        return {
          ...task,
          items: task.items.map((item) => {
            if (item.id == taskItem.id) return { ...item, ...taskItem, status }; // eslint-disable-line
            return item;
          }),
        };
      }
      return task;
    });

    const updatedCurrentWorkflowItem = {
      ...workflowItem,
      configuration: JSON.stringify({
        ...config,
        configWidgetJSON: { ...config.configWidgetJSON, tasks },
      }),
    };
    updateCurrentWorkflowItem(updatedCurrentWorkflowItem);
  }
};

export const updateCurrentTask = (task: Task, status?: ItemStatus): void => {
  const currentWorkflowItem = getStore()?.state?.currentWorkflowItem;
  if (currentWorkflowItem) {
    const workflowItem = currentWorkflowItem;
    const config = JSON.parse(workflowItem.configuration);
    const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();

    const tasks = config.configWidgetJSON.tasks.map((t: Task) => {
      if (t.id === task.id) {
        return {
          ...t,
          hurdleStatus: status,
        };
      }
      return t;
    });

    const updatedCurrentWorkflowItem = {
      ...workflowItem,
      configuration: JSON.stringify({
        ...config,
        configWidgetJSON: { ...config.configWidgetJSON, tasks },
      }),
    };
    updateCurrentWorkflowItem(updatedCurrentWorkflowItem);
  }
};

export default updateCurrentTaskItem;
